import { Home } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';
import { white } from '@styles/colors';

const NotFoundPage = () => {

    const handleGoHome = () => {
        window.location.href = import.meta.env.VITE_MARKETING_SITE_URL;
    };

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                p: 2,
                backgroundColor: white,
            }}
        >
            <Typography
                variant="h1"
                component="h1"
                sx={{ fontSize: { xs: '4rem', md: '6rem' }, fontWeight: 'bold' }}
            >
                404
            </Typography>
            <Typography
                variant="h6"
                sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' }, mb: 2 }}
            >
                Oops! The page you’re looking for doesn’t exist.
            </Typography>
            <Button
                startIcon={<Home />}
                variant="contained"
                color="primary"
                onClick={handleGoHome}
            >
                Go Home
            </Button>
        </Box>
    );
};

export default NotFoundPage;
